import { useTranslation } from "react-i18next";
import AboutOffice from "@assets/images/main/about_office.png";
import AboutOfficeDesk from "@assets/images/main/about_office-desk.png";
import classes from "./About.module.scss";
import BaseContainer from "../../ui/BaseContainer/BaseContainer";
import { AnimationOnScroll } from "react-animation-on-scroll";

const About = () => {
  const { t } = useTranslation();

  return (
    <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce offset={300}>
      <BaseContainer className={classes.about} id="about">
        <h3 className={classes["about-title"]}>{t("about.title")}</h3>
        <h2 className={classes["about-subtitle"]}>{t("about.subtitle")}</h2>
        <div className={classes["about-text-wrapper"]}>
          <p className={classes["about-text"]}>{t("about.text")}</p>
          <p className={classes["about-text"]}>{t("about.text_2")}</p>
        </div>
        <AnimationOnScroll animateIn="animate__zoomIn" animateOnce offset={300}>
          <div className={classes["about-img-wrapper"]}>
            <img className={classes["about-img"]} src={AboutOffice} alt="" />
            <img
              className={classes["about-img__desk"]}
              src={AboutOfficeDesk}
              alt=""
            />
          </div>
        </AnimationOnScroll>
        <h3 className={classes["about-description"]}>
          {t("about.description")}
        </h3>

        <ul className={classes["about-numbers"]}>
          <AnimationOnScroll animateIn="animate__fadeIn" animateOnce delay={0}>
            <li>
              <span>30+</span>
              <p>{t("about.info.block_1")}</p>
            </li>
          </AnimationOnScroll>
          <AnimationOnScroll animateIn="animate__fadeIn" animateOnce delay={50}>
            <li>
              <span>20+</span>
              <p>{t("about.info.block_2")}</p>
            </li>
          </AnimationOnScroll>
          <AnimationOnScroll
            animateIn="animate__fadeIn"
            animateOnce
            delay={150}
          >
            <li>
              <span>8+</span>
              <p>{t("about.info.block_3")}</p>
            </li>
          </AnimationOnScroll>
        </ul>
      </BaseContainer>
    </AnimationOnScroll>
  );
};

export default About;
